module.exports = __webpack_public_path__ + "../css/bundle.main.min.css";